<template>
<div style="height: 100%;">
    <div id="dbalance" class="diagram" style="height: 100%;"></div>
</div>
</template>

<script>
    /* tslint:disable */
    import Highcharts from 'highcharts'
    import Value from '@/views/Value.vue'
    import More from 'highcharts/highcharts-more';
    import Vue from 'vue';
    import { colors } from '@/config';

    More(Highcharts);

    export default {
        name: "D007",
        components: {},
        props: {
            balance: Object
        },

        mounted() {
            this.chart = new Highcharts.chart({

                chart: {
                    type: 'waterfall',
                    renderTo: 'dbalance',
                    backgroundColor: 'transparent',
                },

                credits: {
                    enabled: false,
                },

                title: {
                    text: ''
                },

              xAxis: {
                type: 'category',
                labels: {
                  autoRotation: [0],
                  staggerLines: 1,
                  padding: 10,
                  style: {
                    fontSize: '0.875rem',
                    textOverflow: 'none',
                    whiteSpace: 'normal',
                  },
                },
              },

                yAxis: {
                    title: {
                        text: ''
                    },
                    labels: {
                        style: {
                            fontSize: '1.2rem',
                         },
                        formatter() { return Vue.options.filters.KR(this.value); },
                    },
                    tickPixelInterval: 150
                },

                legend: {
                    enabled: false,
                },

                tooltip: {
                    headerFormat: '<span style="font-size: 1.25rem">{point.key}</span><br/>',
                    pointFormat: '<span><b>{point.y:,.0f} tkr</b></span>',
                    style: {
                        fontSize: '1.25rem',
                    },
                    backgroundColor: colors.Light,
                },

                series: [{
                    upColor: colors.Primary,
                    color: colors.Tertiary,
                    data: [{
                        name: Vue.prototype.$t('Tecknat, men ej inbetalt kapital'),
                        y: this.balance.A
                    }, {
                        name: Vue.prototype.$t('Anläggnings-tillgångar'),
                        y: this.balance.E
                    }, {
                        name: Vue.prototype.$t('Omsättnings-tillgångar'),
                        y: this.balance.K
                    }, {
                        name: Vue.prototype.$t('Balans-omslutning'),
                        isIntermediateSum: true,
                        color: colors.Secondary,
                    }, {
                        name: Vue.prototype.$t('Kortfristiga skulder'),
                        y: -this.balance.Q
                    }, {
                        name: Vue.prototype.$t('Långfristiga skulder'),
                        y: -this.balance.P
                    }, {
                        name: Vue.prototype.$t('Avsättningar'),
                        y: -this.balance.O
                    }, {
                        name: Vue.prototype.$t('Obeskattade reserver'),
                        y: -this.balance.N,
                        color: colors.LightGrey
                    }, {
                        name: Vue.prototype.$t('Eget kapital'),
                        isSum: true,
                        color: colors.Green,
                        negativeColor: colors.Red
                    },],

                    pointPadding: 0
                }]
            });
        },

    }
</script>

<style scoped>
 
</style>
